module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Convention on Biological Diversity":"Convention on Biological Diversity","Page Sub Header":"Page Sub Header"}}')
  delete Component.options._Ctor
}
